// extracted by mini-css-extract-plugin
module.exports = {"toast":"Payment_toast__1Ag_w"};